const checkTicketUnlocked = (ticket?: any, allTickets?: any): boolean => {
    if (
        !ticket?.unlockCondition ||
        !ticket.unlockCondition.dependsOn ||
        ticket.unlockCondition.dependsOn === ''
    ) {
        return true;
    }

    // Find the source ticket this depends on
    const sourceTicket = allTickets?.find(
        (t) => t?.categoryId === ticket.unlockCondition?.dependsOn
    );

    // If source ticket not found, treat as unlocked
    if (!sourceTicket) {
        console.warn(
            `Source ticket ${ticket.unlockCondition.dependsOn} not found for ${ticket.categoryId}`
        );
        return true;
    }

    const soldAmount = sourceTicket.quantityDistributed || 0;
    const totalAmount = sourceTicket.quantityLimit || 0;
    const threshold = ticket.unlockCondition.amount || 0;

    if (ticket.unlockCondition.calculation === 'PERCENTAGE') {
        const percentageSold = totalAmount > 0 ? (soldAmount / totalAmount) * 100 : 0;
        const result = percentageSold >= threshold;
        return result;
    } else if (ticket.unlockCondition.calculation === 'FLAT') {
        // Add validation here for FLAT only
        if (sourceTicket.quantityLimit && threshold > sourceTicket.quantityLimit) {
            console.error(
                `Invalid unlock condition: threshold ${threshold} exceeds source ticket limit ${sourceTicket.quantityLimit}`
            );
            return false;
        }

        const result = soldAmount >= threshold;
        return result;
    }

    return false;
};

export default checkTicketUnlocked;
